import React from 'react';
import { get } from 'lodash/fp';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { confirmOrder } from 'store/actions/data';
import { setCancelAction } from 'store/actions/cancel';
import { getTableButtonText } from 'utils/getText';
import Button from 'components/common/TableButton';
import LabelButton from 'components/LabelStateButton';
import { SUPPORT_EMAIL } from 'enums/info-enums';
import { FONTS } from 'styles/theme/fonts';
import { COLORS } from 'styles/theme/colors';
import { SELLER_PACKAGING, SELLER_CONFIRMED, WITH_COURIER } from 'enums/order-state-enums';

export const ConfirmCancel = ({ order, label }) => {
  const currentTab = useSelector((state) => get('openOrders.currentTab')(state));
  const dispatch = useDispatch();
  const text = getTableButtonText(order);

  const handleClick = () => {
    dispatch(setCancelAction({ isOpen: true, order: order }));
  };

  const handleConfirm = () => {
    dispatch(
      confirmOrder({
        number: order.number,
        order: order,
      }),
    );
  };

  return (
    <ConfirmCancel.OuterContainer>
      <ConfirmCancel.InnerContainer>
        {order.status === SELLER_PACKAGING ||
        order.status === SELLER_CONFIRMED ||
        order.status === WITH_COURIER ? (
          <LabelButton
            status={order.status}
            onClick={handleConfirm}
            order={order}
            label={label}
            text={text}
            hoverText={
              order.status === SELLER_CONFIRMED
                ? `ISSUE GENERATING LABEL:
          We have encountered an issue generating a label for this order.
          Please contact ${SUPPORT_EMAIL} for more information.`
                : null
            }
            disabled={order.status === SELLER_PACKAGING && !order.shippingLabel}
          />
        ) : (
          <Button onClick={handleConfirm} text={text} tab={currentTab} />
        )}
        <ConfirmCancel.CancelSale onClick={handleClick}>cancel sale</ConfirmCancel.CancelSale>
      </ConfirmCancel.InnerContainer>
    </ConfirmCancel.OuterContainer>
  );
};

ConfirmCancel.displayName = 'ConfirmCancel';

ConfirmCancel.OuterContainer = styled.div`
  display: flex;
  align-items: flex-start;
`;

ConfirmCancel.InnerContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;

ConfirmCancel.CancelSale = styled.button`
  background: none;
  border: none;
  border-bottom: 1px solid ${COLORS.primaryConfirmButtonBorder};
  text-align: center;
  display: flex;
  justify-content: center;
  cursor: pointer;
  align-items: center;
  padding: 1px;
  font-family: ${FONTS.default};
  font-size: 14px;
  letter-spacing: 0.25px;
  line-height: 20px;
  text-transform: capitalize;
  color: ${COLORS.primaryText};

  &:focus {
    outline: none;
  }
`;

ConfirmCancel.propTypes = {
  order: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    status: PropTypes.string,
  }),
  label: PropTypes.string,
};

export default ConfirmCancel;
